export default {
      id: "icon-caret-right-usage",
      viewBox: "0 0 7 14",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-caret-right",
      toString: function () {
        return this.url;
      }
    }